"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      loading: true,
      tableData: [],
      taskListVisible: false,
      gridData: [],
      executeCycleVisible: false,
      executeForm: {
        time: ''
      },
      detailCurrentPage: 1,
      detailTotal: 0,
      currentBeanId: '' //当前表格行id
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getTimeTaskLis, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getTimeTaskList)();
            case 2:
              _yield$getTimeTaskLis = _context.sent;
              data = _yield$getTimeTaskLis.data;
              this.tableData = data;
              this.loading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //表格   启动
    startUp: function startUp(val) {
      this.executeCycleVisible = true;
      this.executeForm.time = val.cron;
      this.currentBeanId = val.beanId;
    },
    //表格  停止
    cutOff: function cutOff(val) {
      var _this = this;
      (0, _configure.stopTimeTask)({
        beanId: val.beanId
      }).then(function (res) {
        if (res.code == 1) {
          _this.$message({
            message: '停止定时任务成功',
            type: 'success'
          });
          _this.init();
        }
      });
    },
    // 表格  运行定时任务
    carryOut: function carryOut(val) {
      var _this2 = this;
      (0, _configure.runTimeTask)({
        beanId: val.beanId
      }).then(function (res) {
        if (res.code == 1) {
          _this2.$message({
            message: '运行定时任务成功',
            type: 'success'
          });
          _this2.init();
        }
      });
    },
    //表格  任务日志列表
    checkLog: function checkLog(val) {
      var _this3 = this;
      this.taskListVisible = true;
      this.detailCurrentPage = 1;
      (0, _configure.getTimeTaskLogList)({
        uuid: val.uuid,
        limit: 10,
        page: 1
      }).then(function (res) {
        if (res.code == 1) {
          _this3.gridData = res.rows;
          _this3.detailTotal = res.total;
        }
      });
    },
    // 确认开启
    confirmStarUp: function confirmStarUp(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _configure.startTimeTask)({
            beanId: _this4.currentBeanId,
            cron: _this4.executeForm.time
          }).then(function (res) {
            if (res.code == 1) {
              _this4.executeCycleVisible = false;
              _this4.$message({
                message: '开启定时任务成功',
                type: 'success'
              });
              _this4.init();
            }
          });
        } else {
          return false;
        }
      });
    },
    //弹窗里面的page
    handleDetailSizeChange: function handleDetailSizeChange(val) {},
    handleDetailCurrentChange: function () {
      var _handleDetailCurrentChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(val) {
        var _yield$getTimeTaskLog, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.detailCurrentPage = val;
              _context2.next = 3;
              return (0, _configure.getTimeTaskLogList)({
                uuid: val.uuid,
                limit: 10,
                page: val
              });
            case 3:
              _yield$getTimeTaskLog = _context2.sent;
              rows = _yield$getTimeTaskLog.rows;
              total = _yield$getTimeTaskLog.total;
              this.gridData = rows;
              this.detailTotal = total;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleDetailCurrentChange(_x) {
        return _handleDetailCurrentChange.apply(this, arguments);
      }
      return handleDetailCurrentChange;
    }()
  }
};
exports.default = _default;